module.exports = __webpack_public_path__ + "static/BLOG_230913_AguidetoUizard-sMagicFeatures-bdc29307fc990f0555ab52061d299ac6.webp";